export const MOBILE_BREAKPOINT = '(max-width: 700px)';
export const SMALL_BREAKPOINT = '(max-width: 1220px)';
export const LARGE_BREAKPOINT = '(max-width: 1470px)';
export const HUGE_BREAKPOINT = '(max-width: 2000px)';
